/* eslint-disable no-invalid-this */
import React from 'react';
import Select from '../inputs/Select';
import { colourStyles } from './PublishHelper';
import IconButton from '../buttons/IconButton';

class DownloadSelect extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);

    this.state = {
      selectValue: props.defaultValue
    };
  }

  onChange(selectValue) {
    this.setState({
      selectValue
    });
  }

  onClick() {
    if (this.props.plan_id <= 1) {
      this.props.showPayupModal();
      return;
    }
    this.props.onClick(this.state.selectValue.key);
  }

  render() {
    const { selectOptions, plan_id, className, selectClassName } = this.props;

    return (
      <div className={`flex justify-between ${className}`}>
        <Select
          options={selectOptions}
          valueKey="key"
          labelKey={'label'}
          isSearchable={false}
          getOptionValue={(option) => option.key}
          getOptionLabel={(option) => option.label}
          onChange={this.onChange}
          value={this.state.selectValue}
          className={`form-group w-full ${selectClassName}`}
          styles={colourStyles}
          menuPlacement={'auto'}
          components={{
            IndicatorSeparator: () => null
          }}
        />
        <IconButton
          icon={plan_id <= 1 ? 'lock' : 'download'}
          onClick={this.onClick}
          className="w-10 h-10 rounded ml-2"
        />
      </div>
    );
  }
}

export default DownloadSelect;
